"use strict";
/*
 * Created on 10 15 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var UserProductCategory_1 = require("../model/UserProductCategory");

var UserProductCategoryConverter_1 = require("./UserProductCategoryConverter");
/**
 * Implementation of {@link UserProductCategoryConverter}
 *
 * @author JMe
 */


var UserProductCategoryConverterImpl =
/*#__PURE__*/
function (_UserProductCategoryC) {
  _inherits(UserProductCategoryConverterImpl, _UserProductCategoryC);

  function UserProductCategoryConverterImpl() {
    _classCallCheck(this, UserProductCategoryConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserProductCategoryConverterImpl).apply(this, arguments));
  }

  _createClass(UserProductCategoryConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new UserProductCategory_1.UserProductCategory(UserProductCategory_1.UserProductCategory.schema.id.valueOf(conversions.documentToClassId(source)), UserProductCategory_1.UserProductCategory.schema.userId.valueOfField(source), UserProductCategory_1.UserProductCategory.schema.categoryId.valueOf(conversions.toClassReferenceId(source.categoryId)), UserProductCategory_1.UserProductCategory.schema.processed.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        userId: source.userId,
        categoryId: conversions.toDocumentReferenceId(source.categoryId),
        processed: source.processed
      });
      return document;
    }
  }]);

  return UserProductCategoryConverterImpl;
}(UserProductCategoryConverter_1.UserProductCategoryConverter);

exports.UserProductCategoryConverterImpl = UserProductCategoryConverterImpl;